import { apiSlice } from "../../app/api/apiSlice";

export const managePermissionApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUser: builder.query<void, void>({
        query: () => ({
            url:`/Permission/GetUser`,
            responseHandler: 'json'
        })
    }),

    getAllUser: builder.query<void, void>({
        query: () => ({
            url:`/Permission/GetAllUser`,
            responseHandler: 'json'
        })
    }),

    deleteUser: builder.mutation({
      query: (userId) => ({
          url: `/Permission/DeleteUser?userId=${userId}`,
          method: 'Post',
          responseHandler: 'json',
        //   body : {
        //     ...userId
        //   }
      })
    }),

    insertUser: builder.mutation({
        query: (user) => ({
            url: `/Permission/InsertUser`,
            method: 'Post',
            responseHandler: 'json',
            body : {
                eeNo: user.eeNo,
                SurName: user.surName,
                OtherName: user.otherName,
                Password: '123',
                Roles: user.roles,
                Dept: user.dept,
                TermnDate: '123',
              }
          //   body : {
          //     ...userId
          //   }
        })
    }),
  }),
});


export const {
  useLazyGetUserQuery,
  useDeleteUserMutation,
  useLazyGetAllUserQuery,
  useInsertUserMutation
} = managePermissionApiSlice;
